module.exports = __webpack_public_path__ + "static/d08-f123dfb2369da6ca0902482cd614b253.png";